var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteroperabilityAcrossPlatforms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 64.217C175 75.1605 175 86.1041 175 97.0476C175 101.156 172.776 103.426 168.706 103.43C157.815 103.442 146.928 103.442 136.037 103.43C131.98 103.426 129.689 101.143 129.685 97.056C129.672 75.1688 129.672 53.2817 129.685 31.3946C129.685 27.3157 132.009 25.0039 136.028 25.0039C146.92 25.0039 157.807 25.0039 168.698 25.0039C172.755 25.0039 174.996 27.2783 175 31.3863C175 42.3298 175 53.2734 175 64.217ZM152.353 93.4261C151.318 93.4261 150.279 93.4053 149.243 93.4303C147.93 93.4635 147.211 94.2411 147.165 95.4801C147.119 96.74 147.847 97.5882 149.127 97.6339C151.297 97.7129 153.479 97.7212 155.649 97.6256C156.909 97.5674 157.64 96.7192 157.574 95.4427C157.507 94.187 156.751 93.4677 155.458 93.4344C154.423 93.4053 153.388 93.4303 152.349 93.4303L152.353 93.4261Z",
    fill: "url(#paint0_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.482 135.092C96.5497 135.092 81.6137 135.067 66.6819 135.13C65.1397 135.138 64.7572 134.702 64.8362 133.23C64.9609 130.901 64.936 128.56 64.8445 126.232C64.7946 125.014 65.148 124.656 66.3868 124.664C75.1496 124.718 83.9125 124.664 92.6754 124.702C97.4726 124.723 101.355 122.993 104.12 119.01C105.608 116.864 106.256 114.436 106.256 111.829C106.256 102.91 106.281 93.9875 106.227 85.0688C106.219 83.8423 106.551 83.5055 107.778 83.5221C113.119 83.5886 118.461 83.5886 123.799 83.5221C125.067 83.5055 125.499 83.8173 125.474 85.1478C125.391 89.1893 125.42 93.2391 125.449 97.2847C125.495 103.601 129.714 107.788 136.008 107.796C142.85 107.8 149.697 107.846 156.539 107.758C157.986 107.738 158.218 108.199 158.21 109.505C158.152 117.438 158.148 125.375 158.21 133.309C158.222 134.693 157.911 135.142 156.435 135.138C141.449 135.08 126.463 135.105 111.482 135.105V135.092Z",
    fill: "url(#paint1_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4769 71.618C75.715 71.618 87.9489 71.6388 100.187 71.5889C101.501 71.5848 101.929 71.8384 101.92 73.2645C101.854 85.9711 101.767 98.6776 101.945 111.384C102.008 115.845 98.861 120.39 93.008 120.432C89.0672 120.461 85.1264 120.44 81.1856 120.44C65.6302 120.44 50.0748 120.44 34.5194 120.44C32.2331 120.44 30.0756 120.028 28.2466 118.569C26.139 116.889 25.0291 114.71 25.0332 111.979C25.0457 99.0144 25.0582 86.0459 25.0041 73.0816C25 71.7552 25.4864 71.5931 26.6087 71.5972C38.8967 71.6305 51.1847 71.618 63.4769 71.618Z",
    fill: "url(#paint2_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4852 67.2897C51.1931 67.2897 38.9051 67.2689 26.6129 67.3188C25.2951 67.323 24.921 66.9446 25.0125 65.6723C25.1413 63.8678 24.8836 62.0092 25.1829 60.2421C25.8522 56.2588 29.3731 53.419 33.6506 53.4107C53.5126 53.3691 73.3746 53.365 93.2366 53.4107C98.3622 53.4232 101.871 57.1029 101.883 62.2005C101.883 63.3938 101.796 64.5954 101.908 65.7763C102.024 67.0278 101.567 67.3147 100.358 67.3105C88.0653 67.2648 75.7774 67.2856 63.4852 67.2856V67.2897ZM94.783 62.3502C95.8763 62.3834 96.9488 61.4022 96.8657 60.3294C96.7742 59.1611 96.0717 58.3752 94.9036 58.3461C93.7521 58.317 92.9789 58.9989 92.8542 60.2088C92.7378 61.3356 93.6523 62.3169 94.7789 62.3543L94.783 62.3502ZM82.9273 60.1174C82.8484 59.1195 82.1541 58.4501 80.9985 58.3295C79.951 58.2172 78.8369 59.3024 78.9242 60.3544C79.0198 61.5061 79.6683 62.2587 80.878 62.3418C82.0087 62.4167 82.9357 61.4728 82.9273 60.1174ZM89.8653 60.3377C89.7822 59.0696 89.0755 58.4085 87.8949 58.3295C86.7642 58.2546 85.8622 59.2733 85.9453 60.4542C86.0326 61.6932 86.7684 62.3668 87.9697 62.3252C89.1836 62.2836 89.8071 61.5144 89.8695 60.3377H89.8653Z",
    fill: "url(#paint3_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.619 139.35C126.542 139.35 141.47 139.367 156.393 139.321C157.778 139.317 158.376 139.629 158.198 141.105C158.027 142.485 158.326 143.895 157.981 145.28C157.237 148.265 155.017 150.219 151.979 150.502C151.517 150.543 151.048 150.548 150.582 150.548C124.514 150.548 98.4495 150.552 72.3811 150.548C68.3904 150.548 65.5595 148.531 64.9983 145.08C64.7365 143.463 64.911 141.774 64.8736 140.115C64.8612 139.592 65.094 139.359 65.6053 139.359C66.0708 139.359 66.5364 139.35 67.0062 139.35C81.8798 139.35 96.7534 139.35 111.627 139.35H111.619ZM111.652 141.695C110.517 141.695 109.378 141.695 108.243 141.695C108.193 141.695 108.139 141.695 108.089 141.695C106.68 141.766 105.708 142.61 105.658 143.799C105.612 144.984 106.564 146.007 107.944 146.04C110.318 146.103 112.7 146.103 115.073 146.04C116.478 146.003 117.426 145.013 117.318 143.791C117.197 142.465 116.391 141.75 115.065 141.708C113.93 141.671 112.791 141.7 111.656 141.695H111.652Z",
    fill: "url(#paint4_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.457 174.996C104.257 174.996 97.0527 175.008 89.8528 174.988C87.7868 174.984 86.1199 173.674 85.7416 171.869C85.3425 169.977 86.1864 168.173 87.8575 167.275C88.4769 166.942 89.1378 166.847 89.8071 166.847C104.261 166.838 118.715 166.822 133.168 166.855C135.434 166.859 137.072 168.318 137.334 170.273C137.612 172.372 136.457 174.235 134.432 174.817C133.85 174.984 133.206 174.992 132.591 174.992C125.545 175.004 118.499 175 111.452 174.996H111.457Z",
    fill: "url(#paint5_linear_75_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 162.513C107.287 162.513 103.193 162.493 99.1021 162.53C98.1709 162.538 97.8134 162.418 98.121 161.345C98.6324 159.561 98.9982 157.723 99.1063 155.861C99.152 155.046 99.5261 154.825 100.287 154.825C107.695 154.842 115.102 154.85 122.51 154.821C123.387 154.821 123.607 155.146 123.732 155.969C124.002 157.753 124.381 159.528 124.817 161.283C125.062 162.268 124.83 162.551 123.811 162.538C119.667 162.493 115.522 162.518 111.378 162.518V162.513Z",
    fill: "url(#paint6_linear_75_56)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_56",
    x1: 152.338,
    y1: 25.0039,
    x2: 152.338,
    y2: 103.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_56",
    x1: 111.518,
    y1: 83.5215,
    x2: 111.518,
    y2: 135.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_56",
    x1: 63.4752,
    y1: 71.5889,
    x2: 63.4752,
    y2: 120.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_56",
    x1: 63.4625,
    y1: 53.3779,
    x2: 63.4625,
    y2: 67.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_56",
    x1: 111.54,
    y1: 139.321,
    x2: 111.54,
    y2: 150.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_56",
    x1: 111.509,
    y1: 166.835,
    x2: 111.509,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_56",
    x1: 111.46,
    y1: 154.821,
    x2: 111.46,
    y2: 162.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteroperabilityAcrossPlatforms);
export default __webpack_public_path__ + "static/media/Interoperability_across_platforms.3a99fdf19ab184faaacefda0bd8dc1b1.svg";
export { ForwardRef as ReactComponent };